export default "__VITE_ASSET__Dyg3vNIk__"